import { render } from "./checkContent1226.vue?vue&type=template&id=d94132cc&scoped=true&ts=true"
import script from "./checkContent1226.vue?vue&type=script&lang=ts"
export * from "./checkContent1226.vue?vue&type=script&lang=ts"

import "./checkContent1226.vue?vue&type=style&index=0&id=d94132cc&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94132cc"]])

export default __exports__